export function getAbility(hero, ABILITIES) {
  const abilityList = hero.abilities?.map((id) => ABILITIES[id]);
  return abilityList?.[0];
}
